import axios from 'axios'

const baseUrl = '/api/basis-foundation-official/'

export const apiGetAttachmentsByType = (params) => {
  return axios.get(baseUrl + 'foundation-news-website/get-attachments-by-type', { params })
}

export const apiGetNewsList = (params) => {
  return axios.post(baseUrl + 'foundation-news-website/list', params)
}

export const apiOptionConvert = (params) => {
  return axios.get(baseUrl + 'option-convert/load', { params })
}

export const apiPublicInfoByType = (params) => {
  return axios.get(baseUrl + 'foundation-news-website/get-publicInfo-by-type', { params })
}
